import { LittleModalCreateEdit } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { addDictionaryExtraLine } from '../../../../../../../../utils/globals/dictionary'
import { valueOrDefaultValue } from '../../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { WorkSheetGroupStatusModelType } from '@teinor/erp/types/company/order/sell/workSheet/workSheetGroupStatus'
import { WorkSheetGroupStatusesPayload } from '../../../../../../../../utils/reducers/sells/workSheetGroupStatus'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import withLoading from '../../../../../../../../utils/hoc/withLoading'

type ModalCEWorkSheetGroupStatusProps =  ModalEditComponentProps  & ReduxWorkSheetGroupStatus & { }

const ModalCEWorkSheetGroupStatus: React.FC<ModalCEWorkSheetGroupStatusProps> = ({ allRowData, userPermissions, workSheetGroupStatuses,  ...rest }) => {
    const { t } = useTwinTranslation()

    const fields: FormRender<WorkSheetGroupStatusModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ]
        }
    ]
    if (allRowData && userPermissions) {
        fields[0].elements.push({
            name: 'DefaultWorkSheetProductStatusId',
            label: t('filterByGroupModalPrepareOrder', 'Filtrar por grupo al preparar pedido'),
            component: 'CustomSelectWithSearchBar',
            items: addDictionaryExtraLine(workSheetGroupStatuses?.dictWorkSheetGroupStatus?.[allRowData?.id]?.WorkSheetProductStatusesDict || {}),
            sortItems: true
        })
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (
            <LittleModalCreateEdit fields={parsedFields} url={'/api/app/order/sell/workSheet/workSheetGroupStatus/updateWorkSheetGroupStatus'} translations={{ title: t('editGroupStatus', 'Editar grupo de estados'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />
        )
    }
    return (
        <LittleModalCreateEdit fields={fields} url={'/api/app/order/sell/workSheet/workSheetGroupStatus/createWorkSheetGroupStatus'} translations={{
            title: t('createWorkSheetGroupStatus', 'Crear grupo de estados'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={true} {...rest} />
    )
}

const workSheetGroupStatusesDispatch = {
    setWorkSheetGroupStatuses: (payload: WorkSheetGroupStatusesPayload) => ({ type: 'CHANGE_WORKSHEETGROUPSTATUSES', payload }),
}

export type ReduxWorkSheetGroupStatus = ConnectedProps<typeof workSheetGroupStatusConnect>
const mapWorkSheetGroupStatusConnector = (state: AllReduxPayloads) => ({ workSheetGroupStatuses: state.workSheetGroupStatuses })
const workSheetGroupStatusConnect = connect(mapWorkSheetGroupStatusConnector, workSheetGroupStatusesDispatch)
const workSheetGroupStatusConnectLoading = withLoading(ModalCEWorkSheetGroupStatus, [{ fetchUrl: '/api/app/order/sell/workSheet/workSheetGroupStatus/getAllWorkSheetGroupStatusesComplete', propName: 'workSheetGroupStatuses', setFunctionName: 'setWorkSheetGroupStatuses' }])
const ModalCEWorkSheetGroupStatusConnect = workSheetGroupStatusConnect(workSheetGroupStatusConnectLoading)
export default ModalCEWorkSheetGroupStatusConnect